<template>
  <div
    class="dispatch-container edyst-form-group h-full overflow-y-auto fadeIn"
  >
    <button class="close-button" @click="$emit('discard-modal')">❌</button>
    <div>
      <label for="name" class="text-base font-bold flex items-center"
        ><span class="counter">1</span>Name</label
      >
      <div class="mb-2 bg-container ml-4 relative bar">
        <input
          id="name"
          v-model="announcement.name"
          v-validate="'required'"
          type="text"
          name="name"
          style="margin-top:0;background:#fff;"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("name") }}
        </small>
      </div>
      <div>
        <label for="audience" class="text-base font-bold flex items-center"
          ><span class="counter">2</span>Choose Audience</label
        >
        <div class="bg-container ml-4 relative bar">
          <VueSelect
            id="audience"
            v-model="announcement.segments"
            v-validate="'required'"
            name="segment"
            :options="segmentOptions"
            placeholder="Select Segments"
            label="name"
            :loading="loadingSegments"
            :multiple="true"
            class="bg-white"
            @search="fetchSegments"
          />
          <small class="err-msg text-red block mt-2">
            {{ veeValidateErrors.first("segment") }}
          </small>
        </div>
      </div>
      <label class="flex-no-shrink text-base font-bold mt-2 flex items-center"
        ><span class="counter">3</span>Choose Channel & Template</label
      >
      <div class="bg-container ml-4 relative bar">
        <div class="channel-item">
          <div class="flex items-center mb-4">
            <label for="sms" class="p-0 mx-2">SMS</label>
            <input
              id="sms"
              v-model="channelType"
              type="radio"
              name="template"
              class="radio-btn"
              value="1"
              @change="handleChannelTypeChange()"
            />
            <label for="email" class="p-0 mx-2">Email</label>
            <input
              id="email"
              v-model="channelType"
              type="radio"
              name="template"
              class="radio-btn"
              value="2"
              @change="handleChannelTypeChange()"
            />
          </div>
          <VueSelect
            ref="templateSector"
            v-model="announcement.template"
            v-validate="'required'"
            name="template"
            :options="templateOptions"
            placeholder="Select or search Template"
            label="name"
            :loading="loadingSMSTemplates"
            :multiple="false"
            class="w-full"
            @search="fetchTemplates($event)"
          />
          <small class="err-msg text-red block mt-2">
            {{ veeValidateErrors.first("template") }}
          </small>
        </div>
      </div>
      <label class="flex-no-shrink text-base font-bold mt-2 flex items-center"
        ><span class="counter">4</span>Preview</label
      >
      <div class="bg-container ml-4 relative bar">
        <form
          class="flex items-center preview-form"
          :class="{ 'preview-not-allowed': channelType == '2' }"
          @submit.prevent="handlePreviewSubmit('1')"
        >
          <strong style="width: 4rem;">SMS: </strong>
          <span class="flex-no-shrink mx-2">Send preview to:</span>
          <input
            v-model="previewNumber"
            type="number"
            class="mr-4"
            required
            style="margin-top: 0;background: white;"
          />
          <button class="send-btn">Send</button>
        </form>
        <form
          class="flex items-center preview-form mt-4"
          :class="{ 'preview-not-allowed': channelType == '1' }"
          @submit.prevent="handlePreviewSubmit('2')"
        >
          <strong style="width: 4rem;">Email: </strong>
          <span class="flex-no-shrink mx-2">Send preview to:</span>
          <input
            v-model="previewEmail"
            type="email"
            required
            class="mr-4"
            style="margin-top: 0;background: white;"
          />
          <button class="send-btn">Send</button>
        </form>
      </div>
      <label class="flex-no-shrink text-base font-bold mt-2 flex items-center"
        ><span class="counter">5</span>Save, Send or Schedule Announcement
        <span v-if="editMode" class="font-bold text-blue-dark ml-4">
          {{ status }}</span
        ><button
          v-if="status === 'scheduled'"
          class="rounded-sm px-4 py-1 bg-red hover:bg-red-dark focus:bg-red-dark ml-4 text-white text-sm"
          :disabled="!announcement.is_cancellable"
          @click="handleSubmit('cancel')"
        >
          Cancel
        </button>
      </label>
      <div
        class="bg-container ml-4 relative flex items-center"
        :class="{ sent: status === 'sent' || status === 'failed' }"
      >
        <button
          class="send-btn draft-btn mr-4"
          :disabled="status !== 'drafted'"
          @click="handleSubmit('draft')"
        >
          {{ editMode ? "Update" : "Save to" }} Draft
        </button>
        <button
          class="send-btn"
          :disabled="status !== 'drafted'"
          @click="handleSubmit('send')"
        >
          Send Now
        </button>
        <span class="mx-4">or schedule for</span>
        <ReactWrapper
          :component="component"
          :showTimeSelect="true"
          :selected="scheduleDate"
          dateFormat="MMM d, yyyy h:mm aa"
          placeholderText="Select schedule date"
          @onChange="handleDateChange"
        />
        <button
          class="send-btn ml-4"
          :disabled="
            status === 'sent' ||
              status === 'failed' ||
              !announcement.schedule_for
          "
          @click="handleSubmit('schedule')"
        >
          Schedule
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import { ReactWrapper } from "vuera"
/* react component */
import DatePicker from "react-datepicker"
import {
  getSegments,
  getTemplates,
  createAnnouncements,
  getAnnouncementDetails,
  updateAnnouncements,
  sendAnnouncementPreview,
} from "@/apis/notification/index"

export default {
  components: {
    VueSelect,
    ReactWrapper,
  },
  props: {
    announcementEditObj: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      scheduleDate: "",
      component: DatePicker,
      announcement: {
        name: "Untitled Announcement",
        announcement_status: "drafted",
        segments: [],
        template: null,
        action: "draft",
        schedule_for: "",
      },
      channelType: "1",
      previewNumber: "",
      previewEmail: "",
      loadingSegments: false,
      loadingTemplates: false,
      debounceTimer: null,
      templateDebounceTimer: null,
      segments: [],
      segmentOptions: [],
      smsTemplateOptions: [],
      loadingSMSTemplates: false,
      emailTemplateOptions: [],
      loadingEmailTemplates: false,
    }
  },
  computed: {
    templateOptions() {
      /* eslint-disable-next-line eqeqeq */
      if (this.channelType == "1") {
        return this.smsTemplateOptions
      }
      return this.emailTemplateOptions
    },
    editMode() {
      if (this.announcementEditObj && this.announcementEditObj.id) {
        return true
      }
      return false
    },
    status() {
      return this.announcement.announcement_status
    },
  },
  created() {
    if (this.editMode) {
      this.fetchAnnouncementDetails()
      this.announcement.name = this.announcementEditObj.name
    } else {
      // fetch sms template by default while adding new announcement
      this.fetchTemplates()
    }
    this.fetchSegments()
  },
  methods: {
    handleDateChange(date) {
      this.scheduleDate = date
      this.announcement.schedule_for = date
        ? new Date(date).toISOString()
        : null
    },
    handlePreviewSubmit(channel_type) {
      const payload = {
        channel_type,
        template_id: this.announcement.template.id,
      }
      /* eslint-disable-next-line eqeqeq */
      if (channel_type == "1") {
        payload.send_to = this.previewNumber
        /* eslint-disable-next-line eqeqeq */
      } else if (channel_type == "2") {
        payload.send_to = this.previewEmail
      }
      sendAnnouncementPreview(payload)
        .then(() => {
          this.$noty.info(
            `Preview sent to: ${
              /* eslint-disable-next-line eqeqeq */
              channel_type == "1" ? this.previewNumber : this.previewEmail
            }`
          )
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to send the preview")
        })
    },
    async handleSubmit(action = "draft") {
      const result = await this.$validator.validateAll()
      if (!result) {
        this.$noty.error("Please fix the errors and try again")
        return
      }
      if (this.editMode) {
        this.requestAnnouncementUpdate(action)
      } else {
        this.addNewAnnouncements(action)
      }
    },
    handleChannelTypeChange() {
      this.announcement.template = null
      if (!this.templateOptions || this.templateOptions.length === 0) {
        this.fetchTemplates()
      }
    },
    fetchSegments(query = "") {
      this.loadingSegments = true
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        getSegments(query)
          .then(res => {
            this.segmentOptions = res.data.items
          })
          .catch(err => {
            console.error(err)
            this.$noty.error("Failed to get segments")
          })
          .finally(() => {
            this.loadingSegments = false
          })
      }, 500)
    },
    fetchTemplates(query = "") {
      /* eslint-disable-next-line eqeqeq */
      if (this.channelType == "1") {
        this.loadingSMSTemplates = true
      } else {
        this.loadingEmailTemplates = true
      }
      this.loadingTemplates = true
      clearTimeout(this.templateDebounceTimer)
      this.templateDebounceTimer = setTimeout(() => {
        getTemplates(query, this.channelType)
          .then(res => {
            /* eslint-disable-next-line eqeqeq */
            if (this.channelType == "1") {
              this.smsTemplateOptions = res.data.items
            } else {
              this.emailTemplateOptions = res.data.items
            }
          })
          .catch(err => {
            console.error(err)
            this.$noty.error("Failed to get Templates")
          })
          .finally(() => {
            this.loadingSMSTemplates = false
            this.loadingEmailTemplates = false
          })
      }, 500)
    },
    fetchAnnouncementDetails() {
      const loader = this.$loading.show({ loader: "bars" })
      getAnnouncementDetails(this.announcementEditObj.id)
        .then(res => {
          this.populateFields(res.data)
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to fetch announcement details")
        })
        .finally(() => {
          loader.hide()
        })
    },
    populateFields(data) {
      this.announcement = data
      this.channelType = data.template.channel_type
      this.scheduleDate = data.scheduled_for
        ? new Date(data.scheduled_for)
        : null
    },
    addNewAnnouncements(action) {
      const payload = Object.assign({}, this.announcement)
      payload.segments = payload.segments.map(item => parseInt(item.id))
      payload.action = action
      payload.template_id = payload.template.id
      createAnnouncements(payload)
        .then(res => {
          this.announcement = res.data
          this.showMessage(action)
          this.$emit("announcement-created", res.data)
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to create announcement")
        })
    },
    requestAnnouncementUpdate(action) {
      const payload = Object.assign({}, this.announcement)
      payload.segments = payload.segments.map(item => parseInt(item.id))
      // remove hardcoded value later
      payload.action = action
      payload.template_id = payload.template.id
      updateAnnouncements(this.announcementEditObj.id, payload)
        .then(() => {
          this.showMessage(action)
          this.fetchAnnouncementDetails()
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(`Failed to ${action} announcement`)
        })
    },
    showMessage(action) {
      const actionToVerb = {
        draft: "drafted",
        send: "sent",
        schedule: "scheduled",
        cancel: "cancelled",
      }
      if (action in actionToVerb) {
        const verb = actionToVerb[action]
        this.$noty.info(`Announcement ${verb}`)
      }
    },
  },
}
</script>

<style scoped>
.dispatch-container {
  padding: 2rem;
}

.bg-container {
  padding: 1rem;
  border-radius: 3px;
  background: #e9e9e961;
}

.channel-btn {
  width: 10rem;
  margin-right: 1.2rem;
  padding: 0.5rem 0;
  border-radius: 3px;
  color: white;
  background: #b9b9b9;
}

.channel-item {
  padding: 1rem;
  border-radius: 5px;
  background: white;
  transition: box-shadow 0.3s ease-out;
}

.counter {
  display: flex;
  /* padding: 0.5rem; */
  position: relative;
  left: -0.7rem;
  width: 25px;
  height: 25px;
  border-radius: 100px;
  background: #e7e7e7;
  justify-content: center;
  align-items: center;
}

.bar::before {
  position: absolute;
  top: -1rem;
  left: -1rem;
  width: 3px;
  height: calc(100% + 3rem);
  background: #e7e7e7;
  content: " ";
}

.send-btn {
  width: 10rem;
  padding: 0.4rem 0;
  border-radius: 3px;
  color: #fff;
  background: #6259c5;
}

.draft-btn {
  background: #38c172;
}

button:disabled {
  background: grey;
}

.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.3rem;
  border-radius: 3px;
  background: #ececec;
}

.radio-btn {
  width: 2rem;
  height: 1.5rem;
}

.preview-form {
  transition: opacity 0.3s ease-out;
}

.preview-not-allowed {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}

.sent {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}
</style>

<style>
.dispatch-container.edyst-form-group .react-datepicker__input-container input[type="text"] {
  margin-top: 0;
  background: #fff;
}
</style>
